(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-fit-finder-purchase"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  const STATE_KEY = 'ss_fit_finder_state_v1';
  function readState() {
    try { return JSON.parse(localStorage.getItem(STATE_KEY) || '{}') || {}; } catch (_) { return {}; }
  }
  function element(tag, text, className) {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  }
  function boot() {
    const panel = document.getElementById('ss-fit-finder-panel');
    const result = panel && panel.querySelector('.ss-ff-model-result');
    const dataNode = document.getElementById('ss-fit-finder-data');
    const labelNode = document.getElementById('ss-ff-purchase-labels');
    if (!panel || !result || !dataNode || !labelNode) return false;
    if (panel.dataset.ssPurchaseReady) return true;
    let data, labels;
    try { data = JSON.parse(dataNode.textContent); labels = JSON.parse(labelNode.textContent); } catch (_) { return false; }
    const records = Array.isArray(data.compatibility_records) ? data.compatibility_records : [];
    const templates = new Map(Array.from(document.querySelectorAll('template[data-ss-ff-card]')).map(t => [t.dataset.ssFfCard, t]));
    if (!templates.size) return false;
    panel.dataset.ssPurchaseReady = 'true';
    let active = null;
    let busy = false;
    let serial = 0;
    let measurementDetails = null;
    const input = panel.querySelector('#ss-ff-model-input');
    const text = key => labels[key] || '';
    const rootUrl = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const cartUrl = () => rootUrl() + 'cart';
    function emit(name, detail, snapshot) {
      const saved = snapshot || readState();
      const payload = { event: name, fit_session_id: saved.fit_session_id || null, fit_case_id: saved.fit_case_id || null, ...detail };
      try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (_) {}
      if (saved.fit_case_id && readState().fit_case_id === saved.fit_case_id) {
        try { if (window.SeymourFitFinderBackup) window.SeymourFitFinderBackup.send(name, payload); } catch (_) {}
      }
    }
    function invalidate(showMeasurement) {
      active = null;
      serial += 1;
      if (result.querySelector('[data-ss-ff-shop]')) {
        result.replaceChildren();
        result.style.display = 'none';
      }
      if (showMeasurement && measurementDetails) measurementDetails.open = true;
    }
    function prepareMeasurement() {
      if (measurementDetails) return;
      const content = panel.children[1];
      const search = panel.querySelector('[data-ff-model-search]');
      if (!content || !search) return;
      measurementDetails = element('details', undefined, 'ss-ff-measurement-details');
      measurementDetails.append(element('summary', text('measure')));
      Array.from(content.children).forEach(node => {
        if (node === search) return;
        if (node.classList.contains('ss-ff-divider')) { node.hidden = true; return; }
        measurementDetails.append(node);
      });
      content.append(measurementDetails);
    }
    function availabilityLink(record, title) {
      const link = element('a', text('availability'), 'ss-ff-purchase-help');
      const subject = text('availability') + ' - ' + title + ' - ' + record.recommended_size;
      const body = [record.manufacturer + ' ' + record.model, title, record.recommended_size].join('\n');
      link.href = 'mailto:info@seymoursolar.com?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
      link.addEventListener('click', () => emit('fit_finder_availability_email_clicked', { source: 'model_purchase', record_id: record.record_id, recommended_size: record.recommended_size, equipment: record.manufacturer + ' ' + record.model }));
      return link;
    }
    function addCartLink(status) {
      const link = element('a', text('view_cart'), 'ss-ff-purchase-help');
      link.href = cartUrl();
      status.append(document.createTextNode(' '), link);
    }
    async function request(url, options, timeout) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), timeout || 20000);
      try { return await fetch(url, { ...options, signal: controller.signal, credentials: 'same-origin' }); }
      finally { clearTimeout(timer); }
    }
    async function getCart() {
      const response = await request(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }, 8000);
      if (!response.ok) throw new Error('cart_read_failed');
      return response.json();
    }
    async function openUpdatedDrawer(snapshot, item) {
      const initial = document.querySelector('cart-drawer');
      if (!initial || typeof initial.show !== 'function') {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return false;
      }
      const refreshed = await new Promise(resolve => {
        let settled = false;
        let timer;
        const finish = ok => { if (settled) return; settled = true; clearTimeout(timer); observer.disconnect(); resolve(ok); };
        const observer = new MutationObserver(() => finish(true));
        observer.observe(initial.parentElement || initial, { childList: true, subtree: true });
        timer = setTimeout(() => finish(false), 3500);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });
      if (!refreshed) return false;
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.show !== 'function') return false;
      drawer.querySelectorAll('[data-ss-ff-cart-confirmation]').forEach(n => n.remove());
      const notice = element('p', text('added') + ' ' + item.dataset.title + ' - ' + snapshot.size + '. ' + snapshot.equipment, 'ss-ff-cart-confirmation');
      notice.dataset.ssFfCartConfirmation = 'true';
      notice.setAttribute('role', 'status');
      drawer.prepend(notice);
      const close = panel.querySelector('[data-ff-close]');
      if (close) close.click();
      await drawer.show();
      return true;
    }
    async function addToCart(record, card, status, chosen) {
      if (busy || !active || active.serial !== chosen || card.dataset.available !== 'true') return;
      const state = readState();
      const variantId = card.dataset.variantId;
      if (state.recommendation_record_id !== record.record_id || state.match_result === 'conflict' || !record.variant_ids.map(String).includes(variantId)) return;
      const operationId = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(36).slice(2));
      const snapshot = { ...state, equipment: record.manufacturer + ' ' + record.model, size: record.recommended_size, record_id: record.record_id, variant_id: variantId, operation_id: operationId };
      const properties = {
        '_Fit Finder Session': snapshot.fit_session_id || '', '_Fit Finder Case': snapshot.fit_case_id || '',
        '_Fit Finder Input': 'make_model', '_Equipment': snapshot.equipment,
        '_Recommended Size': snapshot.size, '_Model Recommendation': snapshot.size,
        '_Fit Finder Match': 'matched', '_Compatibility Record': record.record_id,
        '_Fit Finder Add': operationId, [text('equipment')]: snapshot.equipment
      };
      const controls = Array.from(panel.querySelectorAll('input, select, button:not([data-ff-close])'));
      const priorDisabled = new Map(controls.map(n => [n, n.disabled]));
      const button = card.querySelector('[data-ss-ff-add]');
      busy = true;
      controls.forEach(n => { n.disabled = true; });
      result.setAttribute('aria-busy', 'true');
      button.textContent = text('adding');
      status.replaceChildren(document.createTextNode(text('adding')));
      let confirmed = null;
      let uncertain = false;
      let definitiveError = false;
      try {
        const response = await request(rootUrl() + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties }] })
        });
        let body;
        try { body = await response.json(); } catch (_) { throw new Error('unconfirmed_response'); }
        if (!response.ok) {
          if (response.status >= 400 && response.status < 500) {
            definitiveError = true;
            const message = typeof body.description === 'string' ? body.description : text('add_error');
            status.replaceChildren(document.createTextNode(message));
            if (response.status === 422 || response.status === 404) {
              card.dataset.available = 'false';
              card.querySelector('[data-ss-ff-stock]').textContent = text('unavailable');
              card.append(availabilityLink(record, card.dataset.title));
            }
            throw new Error('rejected');
          }
          throw new Error('unconfirmed_response');
        }
        const items = Array.isArray(body.items) ? body.items : [body];
        confirmed = items.find(i => String(i.variant_id || i.id) === variantId && Number(i.quantity) > 0 && i.properties && i.properties['_Fit Finder Add'] === operationId) || null;
        if (!confirmed) throw new Error('unconfirmed_response');
      } catch (_) {
        if (!definitiveError) {
          try {
            const cart = await getCart();
            confirmed = (cart.items || []).find(i => String(i.variant_id || i.id) === variantId && Number(i.quantity) > 0 && i.properties && i.properties['_Fit Finder Add'] === operationId) || null;
          } catch (_) {}
          if (!confirmed) {
            uncertain = true;
            status.replaceChildren(document.createTextNode(text('unconfirmed')));
            addCartLink(status);
          }
        }
      }
      if (confirmed) {
        card.dataset.added = 'true';
        status.replaceChildren(document.createTextNode(text('added') + ' ' + card.dataset.title + ' - ' + snapshot.size));
        addCartLink(status);
        emit('fit_finder_cart_linked', { source: 'model_direct_add', record_id: snapshot.record_id, recommendation_record_id: snapshot.record_id, recommended_size: snapshot.size, variant_id: variantId, product_handle: card.dataset.handle, input_method: 'make_model', quantity: 1, confirmed: true }, snapshot);
        try { await openUpdatedDrawer(snapshot, card); } catch (_) {}
      }
      busy = false;
      controls.forEach(n => { if (n.isConnected) n.disabled = priorDisabled.get(n); });
      result.removeAttribute('aria-busy');
      if (button.isConnected) {
        button.disabled = Boolean(confirmed || uncertain || card.dataset.available !== 'true');
        button.textContent = confirmed ? text('added_short') : uncertain ? text('check_cart') : card.dataset.available !== 'true' ? text('unavailable') : card.dataset.addLabel;
      }
    }
    function upgrade() {
      if (result.querySelector('[data-ss-ff-shop]')) return;
      const heading = result.querySelector('.ss-ff-model-result__heading');
      if (!heading) { if (!active && measurementDetails) measurementDetails.open = true; return; }
      const state = readState();
      const record = records.find(r => r.record_id === state.recommendation_record_id && (r.manufacturer + ' ' + r.model) === heading.textContent);
      if (!record || state.match_result === 'conflict') return;
      const ids = Array.isArray(record.variant_ids) ? record.variant_ids.map(String) : [];
      if (!ids.length || ids.some(id => !templates.has(id))) return;
      const currentSerial = ++serial;
      active = { serial: currentSerial, record_id: record.record_id };
      const wrapper = element('div');
      wrapper.dataset.ssFfShop = record.record_id;
      const title = element('h3', text('matched_for') + ' ' + record.manufacturer + ' ' + record.model, 'ss-ff-purchase-heading');
      const size = element('p', text('matched_size') + ' ' + record.recommended_size, 'ss-ff-purchase-size');
      const intro = element('p', text('choose'), 'ss-ff-purchase-intro');
      wrapper.append(title, size, intro);
      if (record.customer_note && record.customer_note !== 'For the standard, unmodified model.') wrapper.append(element('p', record.customer_note, 'ss-ff-purchase-note'));
      const cards = element('div', undefined, 'ss-ff-purchase-grid');
      const status = element('div', undefined, 'ss-ff-purchase-status');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      const ordered = ids.slice().sort((a, b) => Number(templates.get(b).content.firstElementChild.dataset.available === 'true') - Number(templates.get(a).content.firstElementChild.dataset.available === 'true'));
      ordered.forEach(id => {
        const card = templates.get(id).content.firstElementChild.cloneNode(true);
        card.querySelector('[data-ss-ff-size]').textContent = record.recommended_size;
        const add = card.querySelector('[data-ss-ff-add]');
        add.addEventListener('click', () => addToCart(record, card, status, currentSerial));
        const details = card.querySelector('[data-ss-ff-details]');
        details.addEventListener('click', () => {
          const current = readState();
          if (current.recommendation_record_id === record.record_id) {
            try { localStorage.setItem(STATE_KEY, JSON.stringify({ ...current, product_click: true, selected_variant_id: id })); } catch (_) {}
            emit('fit_finder_model_result_clicked', { record_id: record.record_id, recommended_size: record.recommended_size, variant_id: id, product_handle: card.dataset.handle, source: 'model_product_details' });
          }
        });
        if (card.dataset.available !== 'true') card.append(availabilityLink(record, card.dataset.title));
        cards.append(card);
      });
      wrapper.append(cards, status);
      if (ids.length > 1) {
        const comparison = element('details', undefined, 'ss-ff-purchase-compare');
        comparison.append(element('summary', text('compare')), element('p', text('glass_description')), element('p', text('film_description')));
        wrapper.append(comparison);
      }
      const change = element('button', text('change'), 'ss-ff-purchase-change');
      change.type = 'button';
      change.addEventListener('click', () => { if (input) { input.value = ''; input.dispatchEvent(new Event('input', { bubbles: true })); input.focus(); } });
      wrapper.append(change);
      result.removeAttribute('role');
      result.removeAttribute('aria-live');
      result.replaceChildren(wrapper);
      prepareMeasurement();
      if (measurementDetails) measurementDetails.open = false;
    }
    if (input) input.addEventListener('input', () => {
      invalidate(true);
      const state = readState();
      if (state.recommendation_record_id && window.SeymourFitFinderBackup) {
        window.SeymourFitFinderBackup.startCase({ original_model_query: input.value.trim(), entry_point: state.entry_point, optional_scope_provided: true });
      }
    }, true);
    panel.addEventListener('click', event => {
      const target = event.target.closest('button');
      if (!target) return;
      if (target.classList.contains('ss-ff-model-suggestion') && !busy && window.SeymourFitFinderBackup) {
        const previous = readState();
        window.SeymourFitFinderBackup.startCase({ original_model_query: input ? input.value.trim() : target.textContent, entry_point: previous.entry_point, optional_scope_provided: true });
      }
      if (target.hasAttribute('data-ff-submit')) invalidate(false);
    }, true);
    window.addEventListener('ss-fit-finder-case-started', () => invalidate(true));
    const observer = new MutationObserver(upgrade);
    observer.observe(result, { childList: true, subtree: true });
    upgrade();
    return true;
  }
  function start() {
    if (boot()) return;
    const observer = new MutationObserver(() => { if (boot()) observer.disconnect(); });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 15000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
